// window.addEventListener("load", (event) => {
//   $('.index-block04 .multicolumn-list').slick({
//     autoplay: true,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     variableWidth: true,
//     infinite: false,
//     arrows: false,
//   });
//   $('.index-block04 .multicolumn-list').on('afterChange', function(event, slick, currentSlide) {
//     if (currentSlide === slick.slideCount - 1) {
//       setTimeout(function() {
//         $('.index-block04 .multicolumn-list').slick('slickGoTo', 0);
//       }, 2000);
//     }
//   });
// });
window.addEventListener("load", (event) => {
  function checkBreakPoint() {
    let w = $(window).width();
    if (w <= 749) {
      $('.index-block05 .blog__posts').not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        dots: true,
        appendDots: $('.blog__posts-wrap'),
      });
    } else {
      $('.index-block05 .blog__posts.slick-initialized').slick('unslick');
    }
  }
  $(window).resize(function() {
    checkBreakPoint();
  });
  checkBreakPoint();
});
